import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ArcGetNotificationsArgs {
  @Field(t => Int)
  id!: number

  @Field(t => [String])
  notificationCodes!: string[]
}
